(function () {
  var BOX = '[data-pe-consent-box]';
  var ROOT = '[data-pe-consent]';
  var HINT = '[data-pe-consent-hint]';
  var CHECKOUT =
    'button[name="checkout"], input[name="checkout"], #CartDrawer-Checkout, #checkout, a.cart__checkout-button';

  function root() {
    return document.querySelector(ROOT);
  }

  function applyState() {
    var wrap = root();
    var controls = document.querySelectorAll(CHECKOUT);
    if (!controls.length) return;

    if (!wrap) {
      controls.forEach(function (el) {
        if (el.dataset.peLocked === '1') {
          if (el.tagName === 'A') {
            el.classList.remove('pe-consent-locked');
            el.removeAttribute('aria-disabled');
          } else {
            el.disabled = false;
          }
          delete el.dataset.peLocked;
        }
      });
      return;
    }

    var box = wrap.querySelector(BOX);
    var hint = wrap.querySelector(HINT);
    var ok = box && box.checked;

    controls.forEach(function (el) {
      el.dataset.peLocked = ok ? '' : '1';
      if (el.tagName === 'A') {
        el.classList.toggle('pe-consent-locked', !ok);
        if (ok) el.removeAttribute('aria-disabled');
        else el.setAttribute('aria-disabled', 'true');
      } else {
        el.disabled = !ok;
      }
    });

    if (hint) hint.hidden = !!ok;
  }

  document.addEventListener(
    'click',
    function (e) {
      var el = e.target.closest && e.target.closest(CHECKOUT);
      if (el && el.dataset.peLocked === '1') {
        e.preventDefault();
        e.stopPropagation();
        var hint = document.querySelector(HINT);
        if (hint) hint.hidden = false;
      }
    },
    true
  );

  function save(checked) {
    var wrap = root();
    if (!wrap) return Promise.resolve();

    var payload = checked
      ? {
          subscription_consent: 'yes',
          subscription_consent_text: wrap.dataset.text || '',
          subscription_consent_amount: wrap.dataset.amount || '',
          subscription_consent_plan: wrap.dataset.plan || '',
          subscription_consent_at: new Date().toISOString()
        }
      : {
          subscription_consent: '',
          subscription_consent_text: '',
          subscription_consent_amount: '',
          subscription_consent_plan: '',
          subscription_consent_at: ''
        };

    wrap.classList.add('pe-consent--pending');

    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: payload })
    })
      .catch(function () {})
      .then(function () {
        var w = root();
        if (w) w.classList.remove('pe-consent--pending');
      });
  }

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches(BOX)) return;
    var checked = e.target.checked;
    applyState();
    save(checked);
  });

  document.addEventListener('cart:refresh', applyState);
  document.addEventListener('cart:updated', applyState);

  var observer = new MutationObserver(applyState);

  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) observer.observe(drawer, { childList: true, subtree: true });

    var main = document.querySelector('#main-cart-footer, cart-items');
    if (main) observer.observe(main, { childList: true, subtree: true });

    applyState();
  });

  if (document.readyState !== 'loading') applyState();
})();